import styled, { css } from 'styled-components';

export const RecipePanel = styled.article`
  width: 100%;
  
  @media (min-width: 768px) {
    grid-column: 2;
    grid-row: 1 / 4;
    padding: 0 25px;
    padding-top: 45px;
    padding-bottom: 30px;
    
    border-radius: 6px;
    background-color: ${({ theme }) => theme.white};
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }
  
  @media (min-width: 1024px) {
    grid-row: 1 / 5;
  }
`;

export const RecipeItem = styled.p`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 5px 0;
  
  .title {
    font-weight: 600;
    font-size: 25px;
  }
  
  .price {
    font-weight: 600;
    
    &.small {
      font-size: 20px;
    }
    
    &.large {
      font-size: 24px;
    }
    
    &.bold {
      font-weight: 700;
    }
    
    &.blue {
      color: ${({ theme }) => theme.blue};
    }
  }
  
  .field {
    margin-right: 20px;
    
    font-weight: 600;
    font-size: 16px;
    
    &.normal {
      font-weight: 400;
    }
    
    &.bold {
      font-weight: 700;
    }
  }
  
  .value {
    font-size: 16px;
  
    word-break: break-word;
  }
`;

export const RecipeDelimiter = styled.hr`
  margin: 15px 0;
  padding: 0;
  
  border: none;
  border-bottom: 1px solid #f2f2f2;
`;

export const RecipeAccordion = styled.div`
  margin: 15px 0;
  
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
`;

export const RecipeButton = styled.button`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 15px 0;

  font-weight: 600;
  font-size: 16px;
  line-height: 1;

  transition: color 0.3s;

  &::after {
    content: '';

    transform: rotate(90deg);

    display: inline-block;
    width: 6px;
    height: 9px;
    margin-left: 20px;

    background: transparent no-repeat center / contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%232CB8FE' fill-rule='evenodd' stroke='%232CB8FE' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");

    transition: background-image 0.3s, margin-left 0.3s;

    pointer-events: none;
  }

  &:hover {
    color: ${({theme}) => theme.black};

    &::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%23505050' fill-rule='evenodd' stroke='%23505050' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");
    }
  }

  ${({isOpen}) => isOpen && css`
    &::after {
      transform: rotate(270deg);
    }
  `}
`;

export const RecipeMessage = styled.p`
  margin: 0;
  padding: 0;
  padding-bottom: 15px;
  
  font-size: 16px;
  line-height: 18px;
`;
